export default __webpack_public_path__ + "static/media/F4.cb6aa3f3.mp3";